import { createAction, props } from '@ngrx/store';

import { MediaAssetsModel } from './media-assets.model';
import { AssetsCollection } from '@shared/services/asset/_interfaces_/asset.mapped.interface';

export const SET_MEDIA_ASSETS = '[media assets] Set media assets';
export const SET_AIRLINE_ASSETS = '[media assets] Set airline assets';

export const setMediaAssets = createAction(SET_MEDIA_ASSETS, props<{ data: MediaAssetsModel }>());
export const setAirlineAssets = createAction(SET_AIRLINE_ASSETS, props<{ airlines: AssetsCollection }>());
